import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import AppPage from "./pages/AppPage";
import Login from "./pages/Login"
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import OutlierPage from "./pages/OutlierPage";
import RFMPage from "./pages/RFMPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Pricing from "./pages/Pricing";
import AccountPage from "./pages/AccountPage";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "./supabase";

function AuthRedirectHandler() {
    const navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash;
        if (hash && hash.includes("type=recovery")) {
            navigate("/reset-password");
            return;
        }
        supabase.auth.onAuthStateChange((event) => {
            if (event === "PASSWORD_RECOVERY") {
                navigate("/reset-password");
            }
        });
    }, [navigate]);

    return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthRedirectHandler />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/account" element={
          <ProtectedRoute>
            <AccountPage />
          </ProtectedRoute>
        } />
        <Route path="/app" element={
          <ProtectedRoute>
            <AppPage />
          </ProtectedRoute>
        } />
        <Route path="/outlier" element={<ProtectedRoute><OutlierPage /></ProtectedRoute>} />
        <Route path="/rfm" element={<ProtectedRoute><RFMPage /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
